<template>
<div>
  <el-dialog
    :append-to-body="true"
    title="订单详情" 
    :visible="open"
    :beforeClose="handleCloseModal"
    width="70%">
    <el-row :gutter="20">
      <el-col :span="8"><div class="orderNumStyle">订单号：{{accountDialogData.basic.order_id || ''}}</div></el-col>
      <el-col :span="8"><div class="orderNumStyle">KFC订单号：{{accountDialogData.basic.out_order_id || ''}}</div></el-col>
      <el-col :span="8"><div class="orderNumStyle">订单类型：{{accountDialogData.basic.kfc_order_type || ''}}</div></el-col>
    </el-row>
      <!-- <div><el-button @click="handleCancelOrder"
     v-if="accountDialogData.basic.order_status != 9100 && 
     accountDialogData.basic.order_status != 9010 && 
     accountDialogData.basic.order_status != 10000 && $checkAuth(10000024)" 
     type="primary" class="cancelButtonStyle">取消订单</el-button></div> -->
    
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <div><span class="gird_title">商户名称：</span><div v-if="accountDialogData.basic.dispatch_type!=1"
          class="fixBadge">驻</div>{{accountDialogData.basic.shop_name || ''}}</div>
          <div><span class="gird_title">商户地址：</span>{{accountDialogData.basic.shop_address || ''}}</div>
          <div><span class="gird_title">商户电话：</span>{{accountDialogData.basic.shop_phone || ''}}</div>
          <div><span class="gird_title">送餐距离：</span>{{(accountDialogData.basic.total_distance) || 0}}km</div>
          <div><span class="gird_title">订单金额：</span>{{(accountDialogData.basic.total_price) || 0}}元</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <div><span class="gird_title">用户姓名：</span>{{handleNameShow(accountDialogData.basic.user_name || '')}}</div>
          <div><span class="gird_title">用户电话：</span>{{handlePhoneShow(accountDialogData.basic.user_phone || '')}}</div>
          <div><span class="gird_title">用户地址：</span>{{accountDialogData.basic.user_address || ''}}</div>
          <div><span class="gird_title">用户备注：</span>{{accountDialogData.basic.remark || ''}}</div>
          <div><span class="gird_title">发票信息：</span>{{accountDialogData.basic.invoice_title || ''}}</div>
        </div>
      </el-col>
      <el-col :span="8"><div class="grid-content">
        <div><span class="gird_title">订单状态：</span>{{orderStatus[accountDialogData.basic.order_status] || ''}}</div>
        <div><span class="gird_title">配送类型：</span>{{deliveryType[accountDialogData.basic.delivery_type] || ''}}</div>
        <div><span class="gird_title">下单时间：</span>{{accountDialogData.basic.order_time || ''}}</div>
        <div><span class="gird_title" style="width: 90px">承诺妥投时间：</span>{{accountDialogData.basic.expect_time || ''}}</div>
        <div><span class="gird_title">骑手姓名：</span>{{accountDialogData.basic.rider_name || ''}}</div>
      </div></el-col>
    </el-row>
    
    <div class="orderContentTitle">
    </div>
    <!-- <div class="orderDetailTitleStyle">概览信息</div>
      <div class="detailBasicInfo" v-if="accountDialogData.detail">
        <div><span class="detailBasicTitle">总价：</span><span>{{accountDialogData.detail.total_price || ''}}元</span></div>
        <div><span class="detailBasicTitle">餐盒费：</span><span>{{accountDialogData.detail.box_price || ''}}元</span></div>
        <div><span class="detailBasicTitle">配送费：</span><span>{{accountDialogData.detail.send_price || ''}}元</span></div>
        <div><span class="detailBasicTitle">菜品种类：</span><span>{{accountDialogData.detail.dish_type_num || ''}}种</span></div>
        <div><span class="detailBasicTitle">菜品数量：</span><span>{{accountDialogData.detail.dish_num || ''}}个</span></div>
      </div> -->
    <!-- <div class="orderContentTitle">
    </div> -->
    <div class="mealInfo">
      <div class="orderDetailTitleStyle">商品信息</div>
      <div>
        <el-table
          v-if="accountDialogData.detail"
          :data="accountDialogData.detail.product_detail"
          header-cell-class-name="order_detail_header_style"
          style="width: 100%">
          <el-table-column
            prop="product_name"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="product_num"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="product_unit"
            label="单位"
            width="100">
          </el-table-column>
          <el-table-column
            prop="item_detail"
            label="商品详情">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="orderTrace">
      <div class="orderDetailTitleStyle">系统日志</div>
      <div>
        <el-table
          :data="accountDialogData.sys_log"
          header-cell-class-name="order_detail_header_style"
          style="width: 100%">
          <el-table-column
            prop="order_id"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="operator_name"
            label="操作人">
          </el-table-column>
          <el-table-column
            prop="action_desc"
            label="操作">
          </el-table-column>
          <el-table-column
            prop="action_time"
            label="操作时间">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
  <!-- <el-dialog :visible="showCancelModal" :beforeClose="closeCancelOrderForm">
    <el-form :rules="rules" ref="cancelform" label-width="100px">
      <el-form-item label="取消原因">
        <el-input type="textarea" :value="ruleForm.cancelReason" @input="handleInputReason"></el-input>
      </el-form-item>
      <el-form-item label="判责" prop="charge">
        <el-select v-model="ruleForm.chargeValue">
          <el-option v-for="item in ruleForm.chargeBlame" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="default" @click="clickCancelButton">取消</el-button>
      <el-button type="primary" @click="clickConfirmButton">确认</el-button>
    </div>
  </el-dialog> -->
</div>
</template>

<script>
  import Vue from 'vue';
  import { handlePhoneStr, handleNameStr } from 'common/desensitization';

  const initAccountDialog = {
    basic: {},
    detail: {},
    sys_log: [],
  };
  export default {
    name: 'OrderDetailModal',
    data() {
      return {
        ruleForm: {
          cancelReason: '',
          chargeBlame: [
            { label: '顺丰', value: 'sf' },
            { label: '商家', value: 'sj' },
            { label: '用户', value: 'yh' },
            { label: '骑手', value: 'qs' },
            { label: '其他', value: 'qt' },
          ],
          chargeValue: 'sf',
        },
        rules: {
          reason: [
            { required: true, message: '请输入取消原因', trigger: 'blur' },
            { max: 200, message: '长度不能超过200字', trigger: 'blur' },
          ],
          chagre: [
            { required: true, message: '请选择', trigger: 'change' },
          ],
        },
        showCancelModal: false,
        showAccountDialog: false,
        accountDialogData: initAccountDialog,
        orderStatus: {
          6000: '待处理',
          7020: '已指派',
          7030: '已到店',
          8010: '配送中',
          9100: '已完成',
          8800: '配送失败',
          10000: '已删除',
        },
        deliveryType: {
          0: '预约单',
          1: '即时单',
        },
      };
    },
    props: {
      orderid: {
        type: [String, Number],
      },
      open: {
        type: Boolean,
      },
    },
    mounted() {
    },
    watch: {
      open() {
        if (this.open === true) {
          this.initData();
        }
      },
    },
    methods: {
      handlePhoneShow(phone) {
        // teached by wangshuai
        return handlePhoneStr(phone);
      },
      handleNameShow(name) {
        // teached by wangshuai
        return handleNameStr(name);
      },
      initData() {
        const params = { order_id: this.orderid };
        Vue.axios.get('/order/detail/orderdetail', { params }).then((res) => {
          if (res.data && res.data.data) {
            this.accountDialogData = res.data.data;
            this.showAccountDialog = true;
          }
        });
      },
      handleCloseModal() {
        this.showAccountDialog = false;
        this.$emit('close-modal');
      },
      // handleCancelOrder() {
      //   this.showCancelModal = true;
      // },
      // clickCancelButton() {
      //   this.closeCancelOrderForm();
      // },
      // clickConfirmButton() {
      //   if (this.ruleForm.cancelReason.trim() === '') {
      //     this.$message({
      //       showClose: true,
      //       message: '请填写取消原因',
      //       type: 'error',
      //     });
      //     return false;
      //   }
      //   const params = {
      //     order_id: this.orderid,
      //     cancel_reason: this.ruleForm.cancelReason,
      //     cancel_responsible: this.ruleForm.chargeValue,
      //   };
      //   Vue.axios.get('/order/detail/ordercancel', { params }).then((res) => {
      //     res = res.data;
      //     if (res.errno !== 0) {
      //       this.$message({
      //         showClose: true,
      //         message: res.errmsg,
      //         type: 'error',
      //       });
      //       return false;
      //     }
      //     this.$message({
      //       showClose: true,
      //       message: '取消订单成功',
      //       type: 'success',
      //     });
      //     this.closeCancelOrderForm();
      //     this.initData();
      //     return true;
      //   });
      //   return false;
      // },
      // closeCancelOrderForm() {
      //   this.showCancelModal = false;
      //   const form = this.$refs.cancelform;
      //   form.clearValidate();
      //   this.ruleForm.cancelReason = '';
      //   this.ruleForm.chargeValue = 'sf';
      // },
      // handleInputReason($event) {
      //   this.ruleForm.cancelReason = $event;
      // },
    },
    beforeMount() {
      // this.initData();
    },
  };
</script>
<style lang="less" scope="scope">
  .grid-content > div {
    display: block;
    font-size: 12px;
  }
  .fixBadge {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    display: inline-block;
    border: 2px solid #c91832;
    color: #c91832;
    text-align: center;
    vertical-align: middle;
    margin-right: 5px;
    font-size: 12px;
    line-height: 16px;
    padding: 2px 1px 0 1px;
  }
  .grid-content div {
    font-weight: bold;
  }
  .grid-content div .gird_title {
    display: inline-block;
    width: 80px;
    height: 24px;
    text-align: left;
    vertical-align: top;
    color: #666;
    border-radius: 10px;
    font-weight: normal;
  }
  .orderNumStyle {
    color: #333;
    width: 100%;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .orderDetailTitleStyle {
    color: #c91832;
    font-size: 14px;
    margin-top: 10px;
    font-weight: bold;
  }
  .detailBasicInfo div {
    margin-right: 30px;
    display: inline-block;
    color: #666;
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 10px;
  }
  .detailBasicInfo .detailBasicTitle {
    display: inline-block;
    margin-right: 5px;
  }
  .order_detail_header_style {
    background-color: #f5f7fa;
    height: 20px;
  }
  .mealInfo .el-table th, .mealInfo .el-table td {
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrderDetailModal.vue